export function createGetLoginUserFromStores(deps) {
    return () => {
        const uad = deps.getUnifiedAccountDetails();
        if (!uad)
            return null;
        const ua = uad.user_account_details;
        const profile = deps.getDefaultProfile();
        const program = deps.getCurrentProgram();
        const studentLoginId = deps.getStudentLoginId();
        return {
            verticalId: profile?.vertical_id ?? program?.vertical_id ?? undefined,
            isdCode: ua?.isd_code ?? undefined,
            unifiedAccountId: uad.unified_account_id ?? undefined,
            firstName: ua?.first_name ?? undefined,
            lastName: ua?.last_name ?? undefined,
            email: ua?.email ?? undefined,
            phone: ua?.phone ?? undefined,
            prospectId: ua?.prospect_id ?? undefined,
            programGradeNumber: program?.gradeId ?? undefined,
            profileGradeNumber: ua?.grade?.gradeId ?? undefined,
            studentLoginId: studentLoginId ?? undefined,
            profile: deps.profile() ?? undefined,
        };
    };
}
